import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import { PostAcqUW } from 'components/underwrite/postAcquisition/postAcqUnderwrite';
import { SaveUWDialog } from 'components/underwrite/postAcquisition';
import { RouteWithTitle } from 'routes';
import { Constants } from 'utilities/constants'
import { PostAcqImport } from 'components/underwrite/postAcquisition/import';
import { QueueDrawer } from 'components/queue';

const PostAcq = ({ classes, history, location, match, saveUWDialogParameters, selectedTxnOpp
}) => {
  const getPropertyUWTitle = useCallback(() => {
    if (!location?.pathname) return;
    let title = Constants.RouteTitles.POSTACQ_TASK;
    const pathArr = location.pathname.split('/');
    const oppId = pathArr.pop();
    if (Number.isInteger(parseInt(oppId))) {
      title = title + ' ' + oppId;
    }
    return title;
  }, [location?.pathname]);

  const noSelectedTaskScreen = () => {
    return (
      <div className={classes.noTaskContainer}>
        <Typography variant='h5' style={{ color: 'gray' }}>No task selected</Typography>
        <Button color='primary' variant='outlined' style={{ marginTop: 16 }} onClick={navigateToWorkflow}>Go to Workflow</Button>
      </div>
    )
  }

  const navigateToWorkflow = (() => {
    history.push(Constants.Routes.POSTACQ_WORKFLOW);
  })

  return (
    <>
      <Switch>
        <RouteWithTitle path={`${Constants.Routes.POSTACQ_TASK}/:id`} title={getPropertyUWTitle()}
          render={() => {
            return (
              <PostAcqUW />
            )
          }}
        />
        <RouteWithTitle path={Constants.Routes.POSTACQ_IMPORT} title={Constants.RouteTitles.POSTACQ_IMPORT} component={PostAcqImport} />
        <RouteWithTitle
          path={match.url}
          title={selectedTxnOpp ? '' : Constants.RouteTitles.POSTACQ}
          render={() => { // Redirect to any previous state saved in our Redux store
            if (selectedTxnOpp) {
              const route = Constants.Routes.POSTACQ_TASK;
              return <Redirect to={`${route}/${selectedTxnOpp.id}`} />
            } else {
              return (
                // <Redirect to={Constants.Routes.POSTACQ} />
                noSelectedTaskScreen()
              )
            }
          }}
          exact
        />
        {location.pathname !== Constants.Routes.POSTACQ_WORKFLOW &&
          <Route
            render={() => { // This will handle bad routes, send it back to index
              return <Redirect to={match.url} />;
            }}
          />
        }
      </Switch>
      <QueueDrawer />
    </>
  );
}
const mapStateToProps = state => ({
  selectedTxnOpp: state.postAcqUWState.postAcqUWClientTask,
  saveUWDialogParameters: state.postAcqUWState.saveUWDialogParameters
});

const styles = theme => ({
  splitPane: {
    paddingLeft: '50px'
  },
  container: {
    display: 'flex',
    position: 'relative',
    height: '100%',
  },
  charmContainer: {
    gridArea: 'charm',
    display: 'flex',
    backgroundColor: '#464646' //'#8c8c8c', '#6F6F6F',
  },
  outletContainer: {
    height: '100%',
    width: '100%',
    display: 'flex'
  },
  loadingOverlay: {
    width: '100%',
    display: 'flex'
  },
  loadingText: {
    color: theme.palette.primary.contrastText
  },
  noTaskContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  }
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(PostAcq);